import { render, staticRenderFns } from "./orderStep.vue?vue&type=template&id=7481f934"
import script from "./orderStep.vue?vue&type=script&lang=js"
export * from "./orderStep.vue?vue&type=script&lang=js"
import style0 from "./orderStep.vue?vue&type=style&index=0&id=7481f934&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports